import React, { useCallback, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import FlipModal from "../components/FlipModal";
import CardSlider from "../components/CardSlider";
import {
  divVariants,bounce_right_to_left_variants

} from "shared/components/animations";
import { motion } from "framer-motion/dist/framer-motion";

const CHPTPrePlaying = ({ isActivePlayer, roomId, currentPlayerCard ,buzzer_sound,default_audio_effect}) => {
  const flipButtonClickAction = () => {
    const data = {
      action: "update-status",
      roomId
    };
    console.log(data, "rgyrh");
   Socket.sendMessage(data);
  };
  const handleFlipButtonClick = useCallback(
    _.debounce(() => flipButtonClickAction(), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );
  useEffect(() => {
    if (
      isActivePlayer &&
      !_.isEmpty(default_audio_effect) 
   
    ) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);

  return (
    <motion.div  variants={divVariants}
    initial="hidden"
    animate="visible"
    exit="exit"  >
      {isActivePlayer ? (
        <>
          <motion.h3 variants={bounce_right_to_left_variants}  className="youre-up-title">You’re Up!</motion.h3>
          <FlipModal ButtonClick={() => handleFlipButtonClick()} />
        </>
      ) : (
        <>
          <motion.h3 variants={bounce_right_to_left_variants}  className="waiting-for-players">Waiting for Players...</motion.h3>
          <CardSlider
            currentPlayerCard={currentPlayerCard?.cards}
            showButton={false}
          />
        </>
      )}
    </motion.div>
  );
};

export default CHPTPrePlaying;
